import SelectableRow from '../../selectable_record_table/selectable_row';
import React from 'react';
import { faArrowDownArrowUp } from '@fortawesome/pro-solid-svg-icons';
import { faArrowDown, faArrowUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SelectableRecordTable from '../../selectable_record_table/selectable_record_table';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';

export default function ReportTable({
  allSelected,
  columns,
  isSelected,
  records,
  sortColumn,
  sortOrder,
  onRecordSelected,
  onSelectAll,
  onSortUpdate,
  reportType
}) {
  const clampCellStyle = { maxWidth: 250, width: 250 };
  const clampTextStyle = {
    display: '-webkit-box',
    overflow: 'hidden',
    whiteSpace: 'normal',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2
  };

  const renderTableHeaders = () => {
    return columns.map((column) => {
      let sortIcon = faArrowDownArrowUp;
      if (column.sortable === true && column.key === sortColumn) {
        sortIcon = sortOrder === 'asc' ? faArrowUp : faArrowDown;
      }

      const headerContent = (
        <>
          {column.name}
          {column.sortable && <FontAwesomeIcon className="ms-2" icon={sortIcon}/>}
        </>
      );

      return (
        <th
          className={'text-nowrap ' + (column.sortable ? 'clickable' : '')}
          key={column.key}
          onClick={column.sortable === true ? () => onSortUpdate(column.key) : () => {}}
        >
          {column.tooltip ? (
            <OverlayTrigger
              overlay={<Tooltip id={`tooltip-${column.key}`}>{column.tooltip}</Tooltip>}
              placement="top"
            >
              <span>{headerContent}</span>
            </OverlayTrigger>
          ) : (
            headerContent
          )}
        </th>
      );
    });
  };

  return (
    <SelectableRecordTable
      className="mb-0"
      columnHeaders={renderTableHeaders()}
      hasSelectAll={true}
      hasSelectColumn={true}
      responsive={false}
      selectAllChecked={allSelected}
      stickyHeader
      tableProps={{ striped: true }}
      onSelectAllToggle={onSelectAll}
    >
      {records.map(record => (
        <SelectableRow
          disabled={allSelected}
          key={record.uniqueId || record.id}
          responsive={false}
          selected={isSelected(record)}
          onChange={() => onRecordSelected(record)}
        >
          {columns.map((column) => {
            let valueToShow = record[column.key] || '--';
            if (typeof valueToShow !== 'string') {
              valueToShow = JSON.stringify(valueToShow, '', 2);
            }

            const isAddressCell = column.key === 'address' && reportType === 'property';

            return (
              <td key={column.key} style={isAddressCell ? undefined : clampCellStyle}>
                {isAddressCell ? (
                  <a href={`/projects/${record.id}`}>{valueToShow}</a>
                ) : (
                  <div style={clampTextStyle}>
                    {valueToShow}
                  </div>
                )}
              </td>
            );
          })}
        </SelectableRow>
      ))}
    </SelectableRecordTable>
  );
}

ReportTable.propTypes = {
  allSelected: PropTypes.bool.isRequired,
  columns: PropTypes.array.isRequired,
  isSelected: PropTypes.func.isRequired,
  records: PropTypes.array.isRequired,
  reportType: PropTypes.oneOf(['property', 'leaseComp', 'saleComp', 'user']),
  sortColumn: PropTypes.string,
  sortOrder: PropTypes.string,
  onRecordSelected: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  onSortUpdate: PropTypes.func.isRequired,
};
